define('templates',['handlebars'], function(Handlebars) {

var glob = ('undefined' === typeof window) ? global : window,

Handlebars = glob.Handlebars || require('handlebars');

this["JST"] = this["JST"] || {};

Handlebars.registerPartial("judgebox", this["JST"]["judgebox"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<a class=\"judgebox col-md-4\" data-judge=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n	<div class=\"judgethumb\">\n		<img src=\"";
  if (helper = helpers.thumbnail) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.thumbnail); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" alt=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" border=\"0\">\n		<div class=\"arrowRight\"></div>\n		<div class=\"thumbmask\">\n			<h5>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h5>\n			<span class=\"cornerArrow\"></span>\n		</div>\n	</div>\n</a> ";
  return buffer;
  }));

Handlebars.registerPartial("judgegroup", this["JST"]["judgegroup"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                <div class=\"col-md-8 hidden-xs hidden-sm\">\n                    <div class=\"judgesGridWrap\">\n                        <div class=\"row\">\n                        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.records), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                        </div>\n                    </div>\n                </div>\n                <div class=\"judgesDetail col-md-4\">\n                    <div class=\"judgesDetailInner\">\n                        <div class=\"judgeGroupInfo inner-scrollable\">\n                            <h3 class=\"retired-load_";
  if (helper = helpers.cms) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cms); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_h3\">";
  if (helper = helpers.descTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.descTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</h3>\n                            <p class=\"retired-load_";
  if (helper = helpers.cms) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cms); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_content\">\n                                ";
  if (helper = helpers.desc) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.desc); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                            </p>\n                            <a class=\"btn visible-sm visible-xs meetJudgesBtn\">Meet the <span>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span></a>\n                        </div>\n                    </div>\n                </div>\n            ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                            ";
  stack1 = self.invokePartial(partials.judgebox, 'judgebox', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                        ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                <div class=\"judgesDetail col-md-4\">\n                    <div class=\"judgesDetailInner leftSide\">\n                        <div class=\"judgeGroupInfo inner-scrollable\">\n                            <h3 class=\"retired-load_";
  if (helper = helpers.cms) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cms); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_h3\">";
  if (helper = helpers.descTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.descTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</h3>\n                            <p class=\"retired-load_";
  if (helper = helpers.cms) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.cms); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_content\">\n                                ";
  if (helper = helpers.desc) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.desc); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                            </p>\n                            <a class=\"btn visible-sm visible-xs meetJudgesBtn\">Meet the <span>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span></a>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-8 hidden-xs hidden-sm\">\n                    <div class=\"judgesGridWrap\">\n                        <div class=\"row\">\n                            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.records), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                        </div>\n                    </div>\n                </div>\n            ";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                                ";
  stack1 = self.invokePartial(partials.judgebox, 'judgebox', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                            ";
  return buffer;
  }

  buffer += "<div data-title=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"judgeSection section layout-auto-height\" data-judgegroup=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-title=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <div class=\"judgesWrap container\" data-type=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        <div class=\"row\">\n            ";
  stack1 = (helper = helpers.if_even || (depth0 && depth0.if_even),options={hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), options) : helperMissing.call(depth0, "if_even", (data == null || data === false ? data : data.index), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n    </div>\n</div>\n<div class=\"afterJudgeSection section layout-vertical-center layout-auto-height-no-min\" data-bgimage=\"judges-intro\"></div>";
  return buffer;
  }));

Handlebars.registerPartial("resourcepostclassic", this["JST"]["resourcepostclassic"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"resourcebox col-xs-12 col-sm-6 col-md-4\" data-resource=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n	<div class=\"inner\">\n		<div class=\"postTitle layout-vertical-center\">\n			<h3><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></h3>\n		</div>\n		<a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"btn\" target=\"_blank\">Learn More</a>\n	</div>\n</div>\n";
  return buffer;
  }));

Handlebars.registerPartial("scoringintro", this["JST"]["scoringintro"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return " <div class=\"section pushSection layout-auto-height angleBottomRight\" data-bgimage=\"scoring-intro\">\n	<div class=\"introSection container\" data-title=\"\">\n		<!--<div class=\"load_scoring\">-->\n		<div class=\"row center-height\">\n			<div class=\"col-md-10 col-md-offset-1 content load_scoring_card1\">\n				<h1>Scoring Process</h1>\n				<h2>A careful selection of judges grouped into two categories; the Evaluation Panel and the Selection Committee.</h2>\n				<a class=\"intro-section-btn\" data-scrollto=\".scoreQuestion.section\">Interact with the Rubric<i class=\"icon-icon-arrow-down-rounded\"></i></a>		\n			</div>\n		</div>\n	</div>\n</div>";
  }));

Handlebars.registerPartial("scoringitems", this["JST"]["scoringitems"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n						<div class=\"tick tickTop\" style=\"left:"
    + escapeExpression((helper = helpers.tickLeft || (depth1 && depth1.tickLeft),options={hash:{},data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), ((stack1 = (depth1 && depth1.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options) : helperMissing.call(depth0, "tickLeft", (data == null || data === false ? data : data.index), ((stack1 = (depth1 && depth1.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options)))
    + ";\"></div>\n						<div class=\"tick tickBottom\" style=\"left:"
    + escapeExpression((helper = helpers.tickLeft || (depth1 && depth1.tickLeft),options={hash:{},data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), ((stack1 = (depth1 && depth1.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options) : helperMissing.call(depth0, "tickLeft", (data == null || data === false ? data : data.index), ((stack1 = (depth1 && depth1.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options)))
    + ";\">";
  if (helper = helpers.score) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.score); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n			    	";
  return buffer;
  }

  buffer += "<div class=\"scoreQuestion section pushSection solid-gray-bg\" data-title=\"\" data-bgimage=\"scoring-body\">\n	<div class=\"container\">\n		<div class=\"row\">\n			<a class=\"sbtn scoreCommentBtn primaryBlankBtn hidden-xs\">Leave Comments</a>\n			<h3 class=\"hidden-xs\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <span class=\"scoreRange\">(0-"
    + escapeExpression((helper = helpers.minusOne || (depth0 && depth0.minusOne),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options) : helperMissing.call(depth0, "minusOne", ((stack1 = (depth0 && depth0.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options)))
    + ")</span></h3>\n			<div class=\"text-center\">\n				<div class=\"helpText\"><div class=\"inner\"><h5>Help</h5>";
  if (helper = helpers.helpText) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.helpText); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div></div>\n				<div class=\"commentsText text-center\">\n					<textarea placeholder=\"Comments (minimum 50 characters): Explain your score and provide feedback to the participant.\"></textarea>\n					<div class=\"hidden-xs\">\n						<a class=\"btn\" href=\"#\">Submit Comments</a>\n					</div>\n				</div>\n			</div>\n			<div class=\"scoreHeader\">\n				<div class=\"scoreCounter hidden-xs\">\n					<span class=\"current\">";
  if (helper = helpers.index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n					<span class=\"total\">";
  if (helper = helpers.total) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.total); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n				</div>\n				<div class=\"scoreCounter scoreNav\">\n					<span class=\"prev\"><i class=\"icon-arrow-left-full\"></i></span>\n					<span class=\"next\"><i class=\"icon-arrow-right-full\"></i></span>\n				</div>\n				<div class=\"scoreQuestion\">\n					<span class=\"visible-xs\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n					<span class=\"question-text\">";
  if (helper = helpers.question) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.question); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n					<span class=\"help-question\">\n						<div class=\"icon-icon-help1\"></div>\n					</span>\n					<div class=\"icon-icon-close\"></div>\n				</div>\n			</div>\n			<div class=\"scoreDescription\">\n				<span></span>\n			</div>\n			<div class=\"scoreValue\">\n				<span class=\"valfollow\"></span>\n				<span class=\"valBorderLeft hidden-xs\"></span>\n				<span class=\"valBorderRight hidden-xs\"></span>\n			</div>\n			<div class=\"scoreSliderContainer\">\n				<div class=\"sliderTicks\">\n			    	<span class=\"visible-xs anchorLow\">";
  if (helper = helpers.anchorLow) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.anchorLow); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n					";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			    	<span class=\"visible-xs anchorHigh\">";
  if (helper = helpers.anchorHigh) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.anchorHigh); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n				</div>\n				<span class=\"traitEndL\">";
  if (helper = helpers.anchorLow) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.anchorLow); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n				<div class=\"scoreSlider\">\n					<input id=\"ex";
  if (helper = helpers.index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"scoreSliderInput\" data-slider-id=\"ex";
  if (helper = helpers.index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "Slider\" type=\"text\" data-slider-min=\"0\" data-slider-max=\""
    + escapeExpression((helper = helpers.minusOne || (depth0 && depth0.minusOne),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options) : helperMissing.call(depth0, "minusOne", ((stack1 = (depth0 && depth0.items)),stack1 == null || stack1 === false ? stack1 : stack1.length), options)))
    + "\" data-slider-step=\"0.1\" data-slider-value=\"";
  if (helper = helpers.initScore) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.initScore); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n				</div>\n				<span class=\"traitEndR\">";
  if (helper = helpers.anchorHigh) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.anchorHigh); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n			</div>\n\n		</div>\n		<!--<a class=\"btn scoreCommentBtn primaryBlankBtn hidden-xs hidden-sm \">Leave Comments</a>-->\n	</div>\n</div>";
  return buffer;
  }));

Handlebars.registerPartial("scoringlastcard", this["JST"]["scoringlastcard"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"lastCard section pushSection register layout-auto-height angleTopLeft\" data-bgimage=\"endcard\">\n\n</div>\n";
  }));

Handlebars.registerPartial("sidebarbottommenu", this["JST"]["sidebarbottommenu"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n				<li><span>";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span></li>\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n		";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "<a href=\"";
  if (helper = helpers.link) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.link); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "<div class=\"sidebar-inner-link\">";
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n				";
  stack1 = self.invokePartial(partials.sidebarbottommenu, 'sidebarbottommenu', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			";
  return buffer;
  }

function program8(depth0,data) {
  
  
  return "</a>";
  }

function program10(depth0,data) {
  
  
  return "</div>";
  }

  buffer += "<div class=\"sidebar-inner-list inner-closed\">\n	<span class=\"sidebar-inner-back\">\n		<div class=\"sidebar-icon pe-7s-left-arrow\"></div>\n		<div class=\"sidebar-label\">Back</div>\n	</span>\n	<ul>\n		";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	</ul>\n</div>";
  return buffer;
  }));

Handlebars.registerPartial("sidebaritem", this["JST"]["sidebaritem"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "a";
  }

function program3(depth0,data) {
  
  
  return "div";
  }

function program5(depth0,data) {
  
  
  return "sidebar-item-selected";
  }

function program7(depth0,data) {
  
  
  return "sidebar-item-nested";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "href=\"";
  if (helper = helpers.link) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.link); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

function program11(depth0,data) {
  
  
  return "target=\"_blank\"";
  }

function program13(depth0,data) {
  
  
  return "sidebar-neverwrap";
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n			<div class=\"sidebar-item-data data-";
  if (helper = helpers.dataName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.dataName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div>\n			";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n		";
  stack1 = self.invokePartial(partials.sidebartopmenu, 'sidebartopmenu', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }

  buffer += "\n<";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " class=\"sidebar-item ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isSelected), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.newtab), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n	<div class=\"sidebar-container ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.neverWrap), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n		<div class=\"sidebar-icon ";
  if (helper = helpers.iconClass) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.iconClass); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div>\n		<div class=\"sidebar-label ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.dataName), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n			";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.dataName), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n		</div>\n	</div>\n\n	";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n</";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">";
  return buffer;
  }));

Handlebars.registerPartial("sidebartopmenu", this["JST"]["sidebartopmenu"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n		";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			<li><span>";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span></li>\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n		";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "<a href=\"";
  if (helper = helpers.link) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.link); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "<div class=\"sidebar-inner-link\">";
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n				";
  stack1 = self.invokePartial(partials.sidebarbottommenu, 'sidebarbottommenu', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			";
  return buffer;
  }

function program8(depth0,data) {
  
  
  return "</a>";
  }

function program10(depth0,data) {
  
  
  return "</div>";
  }

  buffer += "<ul class=\"sidebar-tier1 sidebar-list\">\n	";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.items), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</ul>";
  return buffer;
  }));

Handlebars.registerPartial("slideitems", this["JST"]["slideitems"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, self=this, functionType="function", escapeExpression=this.escapeExpression;

function program1(depth0,data) {
  
  
  return "\n<div class=\"item active problem-slide-item\">\n";
  }

function program3(depth0,data) {
  
  
  return "\n<div class=\"item problem-slide-item\">\n";
  }

  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers.unless.call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	<span class=\"slide-category\">\n		";
  if (helper = helpers.category) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.category); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n	</span>\n	<div class=\"slide-image layout-vertical-center\">\n		<img src=\"";
  if (helper = helpers.image) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.image); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n	</div>\n	<span class=\"expand-question\">?</span>\n	<span class=\"expand-question close\">x</span>\n	<div class=\"slide-caption layout-vertical-center\">\n		<p>";
  if (helper = helpers.content) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.content); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n	</div>\n</div>";
  return buffer;
  }));

Handlebars.registerPartial("stepcard", this["JST"]["stepcard"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "	\n    				<a href=\"";
  if (helper = helpers.btnLink) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.btnLink); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" class=\"btn\">";
  if (helper = helpers.btnText) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.btnText); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</a>\n    			";
  return buffer;
  }

  buffer += "<div class=\"process-step-card\">\n	<div class=\"row\">\n		<div class=\"col-xs-12 col-xs-offset-0 col-sm-3 col-sm-offset-1\">\n			<div class=\"step-card-image\">\n				<img src=\"";
  if (helper = helpers.image) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.image); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n			</div>\n		</div>\n		<div class=\"col-xs-12 col-xs-offset-0 col-sm-5 col-sm-offset-1\">\n			<div class=\"step-card-content\">\n    			<h3>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h3>\n    			<p>";
  if (helper = helpers.content) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.content); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n    			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.btnText), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "	\n    		</div>\n    	</div>\n    </div>\n    <div class=\"process-step-next-wrap\">\n        <span class=\"counts\">";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <span class=\"count-divide\">/</span> ";
  if (helper = helpers.total) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.total); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n        <span class=\"next\">View Next Step</span>\n        <div class=\"process-step-next\"><i class=\"icon-icon-arrow-down-rounded\"></i></div>\n    </div>\n    \n\n</div>";
  return buffer;
  }));

Handlebars.registerPartial("timelineinfo", this["JST"]["timelineinfo"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "active";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n		  <!--<a class=\"btn hidden-xs hidden-sm\" href=\"";
  if (helper = helpers.link) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.link); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.btntxt) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.btntxt); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>-->\n		  ";
  return buffer;
  }

  buffer += "<div class=\"item text-center ";
  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" data-period=\"";
  if (helper = helpers.period) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.period); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-period-length=\"";
  if (helper = helpers.periodlength) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.periodlength); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n	<div class=\"inner-item\">\n		  <h3>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h3>\n		  <h6>";
  if (helper = helpers.subtitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.subtitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</h6>\n		  <p>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n		  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.link), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n</div>";
  return buffer;
  }));

this["JST"]["dashboardlinks"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <a href=\"";
  if (helper = helpers.link) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.link); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" title=\"";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n                <div class=\"linkText\">\n                    <img class=\"mobile-nav-icons\" src=\"";
  if (helper = helpers.icon) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.icon); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" width=\"30\" style=\"margin-right: 5px;\">\n                    ";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                </div>\n            </a>\n        ";
  return buffer;
  }

  buffer += "<div class=\"dashboardLinksWrap\">\n    <div class=\"dashboardLinks\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.links), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n</div>";
  return buffer;
  });

this["JST"]["dashboardmenu"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\n				<a href=\"/logout.aspx\" class=\"logoutBtn\">I want to Logout<i class=\"icon-arrow-right\"></i></a>\n				";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n					";
  stack1 = (helper = helpers.checkUser || (depth0 && depth0.checkUser),options={hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data},helper ? helper.call(depth0, "registered", options) : helperMissing.call(depth0, "checkUser", "registered", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			";
  return buffer;
  }
function program4(depth0,data) {
  
  
  return "\n					<a href=\"#login\" class=\"loginBtn\">I want to Login<i class=\"icon-arrow-right\"></i></a>\n					";
  }

function program6(depth0,data) {
  
  
  return "\n					<a href=\"#login\" class=\"loginBtn\">I want to Login<i class=\"icon-arrow-right\"></i></a>\n				";
  }

  buffer += "<div id=\"mainMenu\" style=\"display:none;\">\n    <!--<div class=\"background\"></div>-->\n    <div id=\"centerMenuContent\">\n        <div class=\"newsContent\">\n            <h4>News &amp; Updates</h4>\n        </div>\n    </div>\n    <div id=\"sideMenu\">\n        <div class=\"mobBack visible-xs\">\n            <i class=\"jbc-left-arrow\"></i>\n        </div>\n        <!--<div class=\"menuTitle\">\n            <h4>Navigate</h4>\n        </div>-->\n        <div class=\"menuWrap\">\n            <div id=\"sidebar\"></div>\n            \n        </div>\n        <div class=\"mobile-login\">\n	\n			";
  stack1 = (helper = helpers.checkUser || (depth0 && depth0.checkUser),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, "loggedin", options) : helperMissing.call(depth0, "checkUser", "loggedin", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n		</div>\n		\n        <div class=\"closeWrap\">\n            <span class=\"jbc-x\"></span>\n            <span class=\"hidden\">Close Menu</span>\n        </div>\n    </div>\n    <div id=\"actionMenu\">\n        <div class=\"mobBack visible-xs\">\n            <i class=\"jbc-left-arrow\"></i>\n        </div>\n        <div class=\"daysPromo\">\n            <span class=\"daysCount countText\"></span>\n            <h3 class=\"daytext\">Days Left <br /> to Register</h3>\n        </div>\n        <div class=\"daysLeftPromo\">\n            <span class=\"daysLeft\"></span>\n            <h3>Days Left <br /> to Submit</h3>\n        </div>\n        <div class=\"validationMessage\"></div>\n        <div class=\"actionContent\"></div>\n        <div class=\"actionFooter\">\n            <a href=\"#login\" class=\"loginBtn\">I want to Login<i class=\"icon-arrow-right\"></i></a>\n            <a href=\"#register\" class=\"registerBtn\">I want to Register!<i class=\"icon-arrow-right\"></i></a>\n            <a href=\"/logout.aspx\" class=\"logoutBtn\">I want to Logout<i class=\"icon-arrow-right\"></i></a>\n        </div>\n    </div>\n</div>";
  return buffer;
  });

this["JST"]["footer"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"footer-wrap\">		\n	<div class=\"footer-right\">\n			<div class=\"legalLinks\">\n			<a href=\"#privacy-policy\">Privacy Policy</a>\n			<a href=\"#terms-conditions\">Terms and Conditions</a>\n		</div>\n		<div class=\"copyright\">\n			Rampit, LLC. &copy; 2016. All rights reserved.\n		</div>\n	</div>\n</div>";
  });

this["JST"]["forgotpassword"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div id=\"forgotPassword\" class=\"modal-container\">\n	<div class=\"modal-close icon-icon-close\"></div>\n	<div class=\"modal-title\">Forgot Password</div>\n    <div class=\"form message\" role=\"form\">\n    	<div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <p>Please enter your email and then request a password reset. An email will be sent to begin the process.</p>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"email\" type=\"email\" placeholder=\"Email\" class=\"form-control firstLoad\">\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <button id=\"submitForgotBtn\" class=\"submitForgotBtn btn\" type=\"submit\" disabled=\"disabled\">Reset</button>\n            </div>\n        </div>\n        <div class=\"register_message\" style=\"display: none\">\n            <div class=\"col-xs-12\"></div>\n        </div>\n    </div>\n</div>\n\n<div class=\"toggle-screen\">\n	<a href=\"#login\" class=\"modal-switch\">I want to <strong>Login<strong></a>\n</div>";
  });

this["JST"]["formmessage"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"messageWrap\">\n	<div class=\"modal-close icon-icon-close\"></div>\n	<div class=\"modal-back icon-icon-arrow-left-block\"></div>\n    <div class=\"modal-title\">";
  if (helper = helpers.messageTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.messageTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n    <div class=\"contentModalWrap\">\n        <p>";
  if (helper = helpers.message) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.message); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n    </div>\n</div>\n\n<div class=\"toggle-screen\">\n	<a href=\"#login\" class=\"modal-switch\">I want to <strong>Login</strong></a>\n</div>";
  return buffer;
  });

this["JST"]["judgeinfo"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"judgeinfoWrap inner-scrollable stopOver row\" data-judge=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n	<div class=\"judge-image visible-xs visible-sm col-sm-3\">\n		<img src=\"";
  if (helper = helpers.thumbnail) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.thumbnail); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" alt=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"mobile-img img-responsive\" border=\"0\">\n	</div>\n    <div class=\"col-sm-9 col-md-12\">\n        <h3 class=\"name\">";
  if (helper = helpers.firstName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.firstName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " <span>";
  if (helper = helpers.lastName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.lastName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span></h3>\n        <h4>";
  if (helper = helpers.shortDescription) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.shortDescription); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h4>\n        <p>";
  if (helper = helpers.longDescription) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.longDescription); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n    </div>\n</div>\n<div class=\"nav judgesNav\">\n    <div class=\"navigation-judgetype visible-xs visible-sm\">\n        <span class=\"judgeGroupToggle\">&nbsp;</span>\n    </div>\n	<div class=\"navigation-container\">\n    	<span class=\"icon-icon-arrow-left-block prev\"></span>\n        <span class=\"judgeCounter\">\n            <div class=\"currentCount\"></div>&nbsp;&nbsp;of&nbsp;&nbsp;<div class=\"totalCount\"></div>\n        </span>\n    	<span class=\"icon-icon-arrow-right-block next\"></span>\n    </div>\n    <div class=\"navigation-close\">	\n    	<span class=\"icon-icon-close closeNav\"></span>\n    </div>\n</div>";
  return buffer;
  });

this["JST"]["judgespage"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = self.invokePartial(partials.judgegroup, 'judgegroup', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }

  buffer += "<div id=\"judges\">\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.judgeGroups), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>";
  return buffer;
  });

this["JST"]["lastcard"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\">\n            <img src=\"";
  if (helper = helpers.image) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.image); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" alt=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n        </a>\n    ";
  return buffer;
  }

  buffer += "<div class=\"container\">\n	<div class=\"row\">\n		<div class=\"col-md-12\">\n			<div class=\"sponsorBox\" data-pxscroll=\"0.3\">\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.sponsors), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n			<div class=\"socialBox\" data-pxscroll=\"0.5\">\n	<div class=\"social-box-dropdown\">\n		<!--<a class=\"shareSocial fooBarSocial facebook\" data-action=\"facebook\" href=\"#\"><i class=\"icon icon-icon-facebook\"></i> Facebook</a>-->\n		<a class=\"shareSocial facebook\" data-action=\"facebook\" href=\"#\"><i class=\"icon icon-icon-facebook\"></i> Facebook</a>\n		<a class=\"shareSocial twitter\" data-action=\"twitter\" href=\"#\"><i class=\"icon icon-icon-twitter\"></i> Twitter</a>\n		<a class=\"shareSocial google\" data-action=\"google\" href=\"#\"><i class=\"icon icon-icon-google-plus\"></i> Google+</a>\n	</div>\n	<div class=\"social-icon-slider carousel slide\" data-ride=\"carousel\">\n		<div class=\"carousel-inner\">\n			<div class=\"item active facebook\">\n				<div class=\"icon icon-icon-facebook\"></div>\n			</div>\n			<div class=\"item twitter\">\n				<div class=\"icon icon-icon-twitter\"></div>\n			</div>\n			<div class=\"item google-plus\">\n				<div class=\"icon icon-icon-google-plus\"></div>\n			</div>\n		</div>\n	</div>\n	\n    <div class=\"lastBoxButton\">Share</div>\n    \n</div>\n			\n			<div class=\"registerBox\" data-pxscroll=\"0.7\">\n				<h3>Register Today</h3>\n				<div class=\"retired-load_all_last_card\">\n						<p>Together, we can create solutions to shape Arizona's water future.</p>\n				</div>\n				<div class=\"lastBoxButton\"><a href=\"#register\" class=\"lastCardRegisterBtn\"><span class=\"dayCount\"></span>&#160;<span class=\"dayCountWord\"></span> to <strong>Register</strong></a></div>\n			</div>\n		</div>\n	</div>\n</div>";
  return buffer;
  });

this["JST"]["login"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "value=\"";
  if (helper = helpers.regEmail) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.regEmail); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

  buffer += "<div id=\"login\" class=\"modal-container\">\n	<div class=\"modal-close icon-icon-close\"></div>\n	<div class=\"modal-title\">Login</div>\n	<div class=\"form login\" role=\"form\">\n		<div class=\"row modal-row-pad\">\n			<div class=\"col-xs-12\">\n				<div class=\"form-group\">\n					<input name=\"email\" type=\"email\" id=\"\" placeholder=\"Email\" class=\"form-control firstLoad\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.regEmail), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n				</div>\n			</div>\n		</div>\n		<div class=\"row modal-row-pad\">\n			<div class=\"col-xs-12\">\n				<div class=\"form-group\">\n					<input name=\"password\" type=\"password\"\n						id=\"\" placeholder=\"Password\" class=\"form-control\">\n				</div>\n			</div>\n		</div>\n		\n		<div class=\"row modal-row-pad above-social-login-btn\">\n			<div class=\"col-xs-12\">\n				<button id=\"signinButton\" class=\"signinButton btn\" type=\"submit\" disabled=\"disabled\">Login</button>\n			</div>\n		</div>\n		\n		<div class=\"row modal-row-pad social-login-row\">\n			\n			\n			<div class=\"socialLogin\">\n				<div class=\"row modal-row-pad\">\n					<div class=\"socialLinks\">\n						<span class=\"login-options\">If you prefer, connect with:</span>\n						<a id=\"facebookButton\" href=\"#\">\n							<span class=\"bg\"></span>\n							<span class=\"txt\">Login with Facebook</span>\n						</a>\n						<a id=\"googleButton\" href=\"#\">\n							<span class=\"bg\"></span>\n							<span class=\"txt\">Login with Google</span>\n						</a>\n						\n						<span class=\"login-note\">Before using the federated login buttons above, you must register with the email address connected to that account.</span>\n					</div>\n				</div>\n			</div>\n			\n		</div>\n		\n		\n	</div>\n	\n	<span class=\"subtext below-social-login\">\n		<a href=\"#forgot\">Forgot Password</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"#register\">I don't have an account</a>\n	</span>\n</div>\n<div class=\"toggle-screen\">\n	<a href=\"#register\" class=\"modal-switch\">I want to <strong>Register</strong></a>\n</div>";
  return buffer;
  });

this["JST"]["navbar"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\n        		<span class=\"daysToRegister hidden-xs\">\n					<a href=\"/\" class=\"btn solid navreg retire-modal-trigger\">Return to Prizeware</a>\n					<a class=\"btn solid modal-close\">\n                        <span>Back To <strong class=\"activePageTitle\">Home</strong></span>\n                    </a>\n				</span>\n        	\n			";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n				";
  stack1 = (helper = helpers.checkUser || (depth0 && depth0.checkUser),options={hash:{},inverse:self.program(6, program6, data),fn:self.program(4, program4, data),data:data},helper ? helper.call(depth0, "registered", options) : helperMissing.call(depth0, "checkUser", "registered", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			";
  return buffer;
  }
function program4(depth0,data) {
  
  
  return "\n				<span class=\"daysToRegister hidden-xs\">\n					<a href=\"#login\" class=\"btn solid navreg retire-modal-trigger\">Login</a>\n					<a class=\"btn solid modal-close\">\n					    <span>Back To <strong class=\"activePageTitle\">Home</strong></span>\n                    </a>\n				</span>\n				";
  }

function program6(depth0,data) {
  
  
  return "\n					<span class=\"daysToRegister hidden-xs\">\n						<a href=\"#register\" class=\"btn solid navreg retire-modal-trigger\">\n							<span class=\"dayCount\"></span>&#160;\n							<span><span class=\"dayCountWord\">days</span> to <strong>Register</strong></span>\n						</a>\n						<a class=\"btn solid modal-close\">\n                            <span>Back To <strong class=\"activePageTitle\">Home</strong></span>\n						</a>\n					</span>\n				";
  }

  buffer += "<nav id=\"mainNavbar\" class=\"navbar navbar-default\" role=\"navigation\">\n    <div class=\"text-center\">\n\n        <div class=\"navbar-header\">\n            <a class=\"navbar-brand anim\" href=\"/#home\"></a>\n            <a class=\"navbar-brand-sub\" href=\"/#home\"></a>\n        </div>\n\n        <div class=\"dashboard-menu-container\">\n        	<div class=\"dashboardToggle dropdown\">\n				<a href=\"\">\n					<div class=\"icon hamburger-to-close\">\n						<div class=\"hamburger-middle\"></div>\n					</div>\n				</a>\n			</div>\n        \n        \n        	";
  stack1 = (helper = helpers.checkUser || (depth0 && depth0.checkUser),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, "loggedin", options) : helperMissing.call(depth0, "checkUser", "loggedin", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        \n        \n	\n		</div>\n\n    </div>\n</nav>";
  return buffer;
  });

this["JST"]["newsmenu"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"row newsMenuBox\" data-news=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n	<div class=\"col-xs-12\">\n		<h5>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h5>\n		<div class=\"postInfo\">\n			<p>\n				<span>";
  if (helper = helpers.date) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.date); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n			</p>\n		</div>\n		<div class=\"postDescription\">\n			<p>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " <a class=\"readMoreBtn\" href=\"updates#";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-arrow-right\"></i></a></p>\n		</div>\n	</div>\n</div>";
  return buffer;
  });

this["JST"]["newspost"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<article class=\"row newsbox col-md-12\" data-pagenav=\"true\" data-news=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-title=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <div class=\"text-left news-inner border-box\">\n        <h2>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h2>\n        \n        <div class=\"postInfo\">\n        <div class=\"sml-border\"></div>\n            <p>\n                <span>";
  if (helper = helpers.date) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.date); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n            </p>\n        <div class=\"sml-border\"></div>\n        </div>\n        <a class=\"btn readMoreBtn\">Read <strong>More<strong></a>\n        <!--<div class=\"postDescription\">\n            <p>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n        </div>\n        -->\n        <div class=\"postContent\">\n             <p>\n                <span class=\"postAuthor\">";
  if (helper = helpers.author) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.author); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n            </p> \n            <p>";
  if (helper = helpers.content) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.content); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n        </div>\n    </div>\n</article>";
  return buffer;
  });

this["JST"]["portraitmask"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"portraitmask\" data-bgimage=\"default\">\n    <div class=\"mask-brand\"></div>\n    <div class=\"mask-image\"></div>\n    <div class=\"mask-content\">\n        <h5>\n            This website was designed to be best\n            experienced in portrait view.\n        </h5>\n        <h5>\n            Please rotate your device.\n        </h5>\n    </div>\n</div>";
  });

this["JST"]["problemstatement"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n							";
  stack1 = self.invokePartial(partials.slideitems, 'slideitems', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n						";
  return buffer;
  }

  buffer += "<div class=\"container\">\n	<div class=\"row\">\n		<div class=\"col-md-12\">\n			<div class=\"sliderBox\" data-pxscroll=\"0.8\">\n				<!--<div class=\"problem-statement-slider carousel slide\" data-ride=\"carousel\" data-interval=\"false\">-->\n				<div class=\"problem-statement-slider carousel slide\" data-ride=\"carousel\">\n					<div class=\"caro-nav-container\">\n						<div class=\"caro-count\">\n							<ol class=\"carousel-indicators\" type=\"1\">\n								\n							</ol>\n							\n						</div>\n					</div>\n					<div class=\"carousel-inner\">\n						";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.slideitem), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n					</div>\n				</div>\n			</div>\n\n			<div class=\"statementTextBox fetch_home_card2\" data-pxscroll=\"1.2\">\n				<h3>NEW ARIZONA PRIZE</h3>\n				<p>The Water Innovation Challenge will award a $250,000 prize to a collaborative team in an Arizona community that develops the most innovative and inventive market-based, technological or entrepreneurial solution to advance the sustainability of its water future.</p>\n                <p>Solutions must be scalable to address an Arizona town/city, county, tribe, or region's needs, and, if successful, should also be replicable in other Arizona communities. Community collaborations are required, and new, pilot and shovel-ready projects will be accepted.</p>\n			</div>\n\n			<div class=\"videoBox\" data-pxscroll=\"1\">\n			\n				<div class=\"video\">\n					<!--<video controls=\"true\" id=\"introVideo\" poster=\"img/wic-video-cover.png\">-->\n					<video id=\"introVideo\" poster=\"img/transparent.png\" preload=\"metadata\">\n                        <source type=\"video/ogg\" src=\"img/cms/beyond_the_mirage_trailer.webm\" />\n                        <source type=\"video/webm\" src=\"img/cms/beyond_the_mirage_trailer.webm\" />\n                        <source type=\"video/mp4\" src=\"img/cms/beyond the mirage_trailer.mp4\" />\n                    </video>\n                    <div class=\"play-overlay\"></div>\n                    <div class=\"replay-overlay\"></div>\n                    <div class=\"videoText\">\n					</div>\n                    <div class=\"video-controls\">\n                        <div class=\"seekBar\">\n                            <div class=\"togglePlay\">\n                                <span class=\"play-icon\"></span>\n                                <span class=\"pause-icon\"></span>\n                            </div>\n                            <div class=\"seekMeter\">\n                                <div class=\"seekProgress\"></div>\n                                <input type=\"range\" name=\"videoSeek\" min=\"0\" max=\"100\" />\n                            </div>\n                        </div>\n                    </div>\n				</div>\n				\n				<span class=\"video-caption\">Beyond the Mirage, winner of the Water Consciousness Challenge.</div>\n				\n			</div>\n		</div>\n	</div>\n</div>";
  return buffer;
  });

this["JST"]["processsteps"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = self.invokePartial(partials.stepcard, 'stepcard', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }

  buffer += "<div class=\"container process-container\" data-pxscroll=\"0.5\">\n	<div class=\"row\">\n        <div class=\"col-md-12\">\n			<h2>How to Compete</h2>\n		</div>\n	</div>\n    <div class=\"row cards-container\">\n        <div class=\"col-md-12\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.steps), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n    </div>\n</div>";
  return buffer;
  });

this["JST"]["register"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "value=\"";
  if (helper = helpers.firstName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.firstName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "value=\"";
  if (helper = helpers.lastName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.lastName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "value=\"";
  if (helper = helpers.regEmail) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.regEmail); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

  buffer += "<div id=\"register\" class=\"modal-container\">\n	<div class=\"modal-close icon-icon-close\"></div>\n	<div class=\"modal-title\">Register</div>\n    <div class=\"form\" role=\"form\">\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"fname\" type=\"text\" id=\"\" placeholder=\"First Name\" class=\"form-control firstLoad\" required=\"required\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.firstName), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"lname\" type=\"text\" id=\"\" placeholder=\"Last Name\" class=\"form-control\" required=\"required\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.lastName), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"email\" type=\"text\" id=\"\" placeholder=\"Email\" class=\"form-control\" required=\"required\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.regEmail), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"password\" type=\"password\" id=\"\" placeholder=\"Password\" class=\"form-control\" required=\"required\">\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\" >\n                <div class=\"form-group checkGroup\">\n                  <div class=\"form-control\">\n                	<input name=\"chkAgree\" id=\"chkAgree\" type=\"checkbox\" required=\"required\">\n                	<label for=\"chkAgree\"></label>\n                    <span>\n                        I accept the <a href=\"/#terms-conditions\">Terms & Conditions</a>\n                    </span>\n                  </div>\n                </div>\n                <!-- Hidden Fields -->\n                <input name=\"type\" type=\"hidden\" />\n            </div>\n        </div>\n        <div class=\"row modal-row-pad\">\n            <div class=\"col-xs-12\">\n                <button id=\"submitRegisterBtn\" class=\"submitRegisterBtn btn\" type=\"submit\" disabled=\"disabled\">Register</button>\n            </div>\n        </div>\n		<div class=\"register_message\" style=\"display: none\">\n			<div class=\"col-xs-12\">\n			</div>\n		</div>\n    </div>\n</div>\n\n<div class=\"toggle-screen\">\n	<a href=\"#login\" class=\"modal-switch\">I want to <strong>Login</strong></a>\n</div>\n";
  return buffer;
  });

this["JST"]["resetpassword"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "value=\"";
  if (helper = helpers.regEmail) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.regEmail); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"";
  return buffer;
  }

  buffer += "<div id=\"resetPassword\" class=\"modal-container\">\n    <div class=\"modal-title\">Reset Password</div>\n    <div class=\"form\" role=\"form\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"email\" type=\"email\"\n                           id=\"\" placeholder=\"Email\" class=\"form-control firstLoad\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.regEmail), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div class=\"form-group\">\n                    <input name=\"password\" type=\"password\" placeholder=\"Password\" class=\"form-control\" autocomplete=\"false\">\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <button id=\"resetPasswordButton\" class=\"btn\" type=\"submit\" disabled=\"disabled\">Reset Password</button>\n            </div>\n        </div>\n        <!-- <div class=\"subtext\">\n			<a href=\"#forgot\">Forgot Password</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"/#register\">I don't have an account</a>\n		</div> -->\n    </div>\n</div>";
  return buffer;
  });

this["JST"]["resourcepostclassic"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var stack1, self=this, helperMissing=helpers.helperMissing, functionType="function", blockHelperMissing=helpers.blockHelperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n				\n	";
  options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data}
  if (helper = helpers.desktop_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.desktop_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.desktop_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	";
  options={hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data}
  if (helper = helpers.phone_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.phone_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.phone_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	";
  options={hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data}
  if (helper = helpers.xs_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.xs_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.xs_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	\n	\n		";
  stack1 = self.invokePartial(partials.resourcepostclassic, 'resourcepostclassic', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	";
  options={hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data}
  if (helper = helpers.xs_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.xs_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.xs_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	";
  options={hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data}
  if (helper = helpers.phone_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.phone_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.phone_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	\n	";
  options={hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data}
  if (helper = helpers.desktop_width) { stack1 = helper.call(depth0, options); }
  else { helper = (depth0 && depth0.desktop_width); stack1 = typeof helper === functionType ? helper.call(depth0, options) : helper; }
  if (!helpers.desktop_width) { stack1 = blockHelperMissing.call(depth0, stack1, {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data}); }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n		";
  stack1 = (helper = helpers.rowOpen || (depth0 && depth0.rowOpen),options={hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 3, options) : helperMissing.call(depth0, "rowOpen", (data == null || data === false ? data : data.index), 3, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return "\n		<div class=\"row\">\n		";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n		";
  stack1 = (helper = helpers.rowOpen || (depth0 && depth0.rowOpen),options={hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 2, options) : helperMissing.call(depth0, "rowOpen", (data == null || data === false ? data : data.index), 2, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n		";
  stack1 = (helper = helpers.rowOpen || (depth0 && depth0.rowOpen),options={hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 1, options) : helperMissing.call(depth0, "rowOpen", (data == null || data === false ? data : data.index), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "	\n		";
  stack1 = (helper = helpers.rowClose || (depth0 && depth0.rowClose),options={hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 1, options) : helperMissing.call(depth0, "rowClose", (data == null || data === false ? data : data.index), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }
function program10(depth0,data) {
  
  
  return "\n		</div>\n		";
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "	\n		";
  stack1 = (helper = helpers.rowClose || (depth0 && depth0.rowClose),options={hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 2, options) : helperMissing.call(depth0, "rowClose", (data == null || data === false ? data : data.index), 2, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "	\n		";
  stack1 = (helper = helpers.rowClose || (depth0 && depth0.rowClose),options={hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.index), 3, options) : helperMissing.call(depth0, "rowClose", (data == null || data === false ? data : data.index), 3, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }

  stack1 = helpers.each.call(depth0, (depth0 && depth0.posts), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  });

this["JST"]["scoring"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  if (helper = helpers.scoringitems) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.scoringitems); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  });

this["JST"]["sidebar"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n		";
  stack1 = self.invokePartial(partials.sidebaritem, 'sidebaritem', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }

  buffer += "<div>\n	";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.menuItems), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>";
  return buffer;
  });

this["JST"]["sidenav"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"sideNav\">\n    <span class=\"prev\"><i class=\"icon-arrow-up\"></i></span>\n        <span class=\"counter\">\n            <div class=\"currentCount\">1</div>\n            <div class=\"totalCount\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.records)),stack1 == null || stack1 === false ? stack1 : stack1.length)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</div>\n        </span>\n    <span class=\"next\"><i class=\"icon-arrow-down\"></i></span>\n</div>";
  return buffer;
  });

this["JST"]["social"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<li><div class=\"socialicon socialicon-";
  if (helper = helpers.key) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.key); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></div><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></li>";
  return buffer;
  });

this["JST"]["timeline"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n					 ";
  stack1 = self.invokePartial(partials.timelineinfo, 'timelineinfo', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n				  ";
  return buffer;
  }

function program3(depth0,data,depth1) {
  
  var buffer = "", stack1, stack2, helper, options;
  buffer += "\n			";
  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.programWithDepth(6, program6, data, depth1),fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n		\n			<div class=\"timelinePoint ";
  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.first), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (data == null || data === false ? data : data.last), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n				data-toggle=\"tooltip\" data-placement=\"top\" data-html=\"true\" data-trigger=\"hover\" title=\"<span>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span><span>";
  if (helper = helpers.balloonsubtitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.balloonsubtitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</span>\"\n				style=\"left:";
  stack1 = (depth1 && depth1.msIncrement);
  stack2 = (helper = helpers.math || (depth0 && depth0.math),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.timestamp), "-", (depth1 && depth1.start), options) : helperMissing.call(depth0, "math", (depth0 && depth0.timestamp), "-", (depth1 && depth1.start), options));
  buffer += escapeExpression((helper = helpers.math || (depth0 && depth0.math),options={hash:{},data:data},helper ? helper.call(depth0, stack2, "*", stack1, options) : helperMissing.call(depth0, "math", stack2, "*", stack1, options)))
    + "%;\">\n			</div>\n	    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <div class=\"connectLine\" data-period=\"";
  if (helper = helpers.period) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.period); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                 style=\"left:-1028px;width:1000px\">\n            </div>\n			";
  return buffer;
  }

function program6(depth0,data,depth2) {
  
  var buffer = "", stack1, stack2, stack3, helper, options;
  buffer += "\n				<div class=\"connectLine\" data-period=\"";
  if (helper = helpers.period) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.period); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"\n					left: ";
  stack1 = (depth2 && depth2.msIncrement);
  stack2 = (depth2 && depth2.start);
  stack3 = (helper = helpers.prev || (depth2 && depth2.prev),options={hash:{},data:data},helper ? helper.call(depth0, (depth2 && depth2.timelinePoints), (data == null || data === false ? data : data.index), "timestamp", options) : helperMissing.call(depth0, "prev", (depth2 && depth2.timelinePoints), (data == null || data === false ? data : data.index), "timestamp", options));
  stack2 = (helper = helpers.math || (depth2 && depth2.math),options={hash:{},data:data},helper ? helper.call(depth0, stack3, "-", stack2, options) : helperMissing.call(depth0, "math", stack3, "-", stack2, options));
  buffer += escapeExpression((helper = helpers.math || (depth2 && depth2.math),options={hash:{},data:data},helper ? helper.call(depth0, stack2, "*", stack1, options) : helperMissing.call(depth0, "math", stack2, "*", stack1, options)))
    + "%;\n					width:calc(";
  stack1 = (depth2 && depth2.msIncrement);
  stack2 = (helper = helpers.prev || (depth2 && depth2.prev),options={hash:{},data:data},helper ? helper.call(depth0, (depth2 && depth2.timelinePoints), (data == null || data === false ? data : data.index), "timestamp", options) : helperMissing.call(depth0, "prev", (depth2 && depth2.timelinePoints), (data == null || data === false ? data : data.index), "timestamp", options));
  stack2 = (helper = helpers.math || (depth0 && depth0.math),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.timestamp), "-", stack2, options) : helperMissing.call(depth0, "math", (depth0 && depth0.timestamp), "-", stack2, options));
  buffer += escapeExpression((helper = helpers.math || (depth0 && depth0.math),options={hash:{},data:data},helper ? helper.call(depth0, stack2, "*", stack1, options) : helperMissing.call(depth0, "math", stack2, "*", stack1, options)))
    + "% - 28px);\">\n				</div>\n			";
  return buffer;
  }

function program8(depth0,data) {
  
  
  return "first active";
  }

function program10(depth0,data) {
  
  
  return "last";
  }

  buffer += "<div class=\"timelineContainer\">\n	<div id=\"timelineInfo\" class=\"timelineInfoContainer carousel slide\" data-interval=\"false\">\n		<div class=\"timelineWrap\">\n			<div class=\"carousel-inner timelineInfo\" role=\"listbox\">\n				  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.timelinePoints), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			</div>\n		</div>\n		<a class=\"timelineNav carousel-control left hidden-xs hidden-sm\" data-slide=\"prev\" data-target=\"#timelineInfo\"><div class=\"inner\"></div></a>\n		<a class=\"timelineNav carousel-control right hidden-xs hidden-sm\" data-slide=\"next\" data-target=\"#timelineInfo\"><div class=\"inner right\"></div></a>\n	</div>\n	<div class=\"timeline-bottom\">\n		<div class=\"timeline\">\n		";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.timelinePoints), {hash:{},inverse:self.noop,fn:self.programWithDepth(3, program3, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	    </div>\n\n	    <div class=\"timeline-calendar\"><ul></ul></div>\n	    <div class=\"timeline-period\"><h3></h3><h6></h6></div>\n    </div>\n    <div class=\"timeline-toggle\">\n    	<div class=\"detail\">\n    		<img src=\"img/detail.png\" />\n    	</div>\n    	<div class=\"overview\">\n    		<img src=\"img/overview.png\" />\n    	</div>\n    </div>\n\n</div>";
  return buffer;
  });

this["JST"]["validationmessage"] = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"messageWrap\">\n	<div class=\"modal-close icon-icon-close\"></div>\n	<div class=\"modal-back icon-icon-arrow-left-block\"></div>\n    <div class=\"modal-title\">";
  if (helper = helpers.messageTitle) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.messageTitle); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n    <div class=\"contentModalWrap\">\n        <p>";
  if (helper = helpers.message) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.message); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n    </div>\n</div>\n\n<div class=\"toggle-screen\">\n	<a href=\"#login\" class=\"modal-switch\">I want to <strong>Login</strong></a>\n</div>";
  return buffer;
  });

if (typeof exports === 'object' && exports) {module.exports = this["JST"];}

return this["JST"];

});
